import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserMoodFrequency } from 'user/model/user-mood-frequency';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface CreateUserMoodParams {
	readonly frequency?: UserMoodFrequency;
	readonly feelings?: string;
	readonly mood: number;
}

@Injectable({ providedIn: 'root' })
export class CreateUserMoodApiMutation extends ApiMutation<
	string,
	CreateUserMoodParams
> {
	client = 'iam';
	document = gql`
		mutation CreateUserMood(
			$mood: Int!
			$feelings: String
			$frequency: UserMoodFrequency
		) {
			createUserMood(mood: $mood, feelings: $feelings, frequency: $frequency)
		}
	`;
	method = 'createUserMood';
}
